export default "__VITE_ASSET__bhalJWsO__"